import { fromStateNameToCode } from "../../helpers/stateHelpers";

/**
 * Normalize state in an address object.
 * Extracts stateAddress field and converts full state name to 2-letter code.
 * 
 * @param {Object} address - Address object with stateAddress field
 * @returns {Object} - Address object with normalized stateAddress
 */
export function normalizeAddressState(address) {
  if (!address || typeof address !== "object") {
    return address;
  }

  const normalized = { ...address };
  if (normalized.stateAddress) {
    const code = fromStateNameToCode(normalized.stateAddress);
    if (code) {
      normalized.stateAddress = code;
    }
  }

  return normalized;
}
